"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _typeof2 = require("babel-runtime/helpers/typeof");

var _typeof3 = _interopRequireDefault(_typeof2);

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reactDom = require("react-dom");

var _reactDom2 = _interopRequireDefault(_reactDom);

var _path = require("path");

var _path2 = _interopRequireDefault(_path);

var _DateTime = require("../Util/DateTime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//Inspirado en https://github.com/eisneim/react-html5-video

var videoEvents = ["play", "pause", "playing", "abort", "progress", "ratechange", "canplay", "canplaythrough", "durationchange", "emptied", "ended", "loadeddata", "loadedmetadata", "loadstart", "seeked", "seeking", "stalled", "suspend", "timeupdate", "volumechange", "waiting", "error", "encrypted", "mozaudioavailable", "interruptbegin", "interruptend"];

var Video = function (_Component) {
  (0, _inherits3.default)(Video, _Component);

  function Video(props, context) {
    (0, _classCallCheck3.default)(this, Video);

    // store all public handler here, and return this api object to parent component;
    var _this = (0, _possibleConstructorReturn3.default)(this, (Video.__proto__ || (0, _getPrototypeOf2.default)(Video)).call(this, props, context));

    _this.api = {};
    var pubHandlers = ["togglePlay", "play", "pause", "toggleMute", "toggleSubtitle", "setTime", "fullscreen", "volume"];
    // save public handlers to api object
    pubHandlers.forEach(function (name) {
      _this["_" + name] = _this.api[name] = _this["_" + name].bind(_this);
    });
    // manually bind all handlers
    var handlers = ["metaDataLoaded", "ended", "timeupdate", "durationchange", "progress", "canplay"];
    handlers.forEach(function (name) {
      return _this["_" + name] = _this["_" + name].bind(_this);
    });

    return _this;
  }

  (0, _createClass3.default)(Video, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      /**
       * register some video event listener here;
       */
      this.$wraper = _reactDom2.default.findDOMNode(this);
      var $video = this.$video = this.api.$video = _reactDom2.default.findDOMNode(this.refs.video);
      // window.$video = $video;
      $video.addEventListener("loadedmetadata", this._metaDataLoaded);
      $video.addEventListener("ended", this._ended);
      // this update interval gap is too big make progressbar not snapy
      // $video.addEventListener("timeupdate", this._timeupdate )
      $video.addEventListener("progress", this._progress);
      $video.addEventListener("canplay", this._canplay);

      if (this.props.autoPlay && !this.seekbarUpdateTimer) this.seekbarUpdateInterval();
    }

    /**
     * after metaData Loaded we can get video dimentions and set width,height of video wraper;
     */

  }, {
    key: "_metaDataLoaded",
    value: function _metaDataLoaded(e) {
      //console.log("metadata loaded")
      if (this.props.metaDataLoaded && typeof this.props.metaDataLoaded == "function") {
        this.props.metaDataLoaded(this.api);
      }

      // calculate width of seek bar and progress;
      this.$seekbarWraper = _reactDom2.default.findDOMNode(this.refs.seekbarWraper);
      this.setState({
        duration: (0, _DateTime.formatTime)(this.$video.duration)
      });
    }
  }, {
    key: "_ended",
    value: function _ended(e) {
      //console.log("video ended")
      if (this.props.ended && typeof this.props.ended == "function") {
        this.props.ended();
      }
    }
  }, {
    key: "_canplay",
    value: function _canplay(e) {
      //Incluimos esta función para lanzar play debido a que autoplay sobre el elemento html5 no está funcionando por razones desconocidas
      //console.log("can play video")
      if (this.props.autoPlay) {
        this.$video.play();
      }
    }
  }, {
    key: "seekbarUpdateInterval",
    value: function seekbarUpdateInterval() {
      this.seekbarUpdateTimer = setInterval(this._timeupdate, 80);
    }
  }, {
    key: "_setTime",
    value: function _setTime(percent, isPercent) {
      if (this.state.seekDisabled) return;
      if (isPercent && percent > 100) return;
      var time = isPercent ? percent * this.$video.duration / 100 : percent;
      //console.log("change time", time )
      if (this.$video.fastSeek) {
        this.$video.fastSeek(time);
      } else {
        this.$video.currentTime = time;
      }

      this.setState({
        seekProgress: percent
      });
    }

    // update seek bar width;

  }, {
    key: "_timeupdate",
    value: function _timeupdate(e) {
      var percent = this.$video.currentTime / this.$video.duration * 100;
      var newState = {
        seekProgress: percent,
        currentTime: (0, _DateTime.formatTime)(this.$video.currentTime)
      };
      if (this.$video.currentTime >= this.$video.duration) {
        newState.isPlaying = false;
      }
      this.setState(newState);
    }
  }, {
    key: "_durationchange",
    value: function _durationchange() {}

    // loading progress bar

  }, {
    key: "_progress",
    value: function _progress(e) {
      var buf = this.$video.buffered;
      var total = 0;
      for (var ii = 0; ii < buf.length; ii++) {
        total += buf.end(ii) - buf.start(ii);
      }
      this.setState({
        loadedProgress: total / this.$video.duration * 100
      });
    }
  }, {
    key: "_togglePlay",
    value: function _togglePlay() {
      //console.log("toggle play")
      if (!this.seekbarUpdateTimer) this.seekbarUpdateInterval();

      if (!this.state.isPlaying) {
        if (this.$video.currentTime >= this.$video.duration) this.$video.currentTime = 0;
        this.$video.play();
        this.setState({
          isPlaying: true
        });
      } else {
        this.$video.pause();
        this.setState({
          isPlaying: false
        });
      }
    }
  }, {
    key: "_pause",
    value: function _pause() {
      //console.log("play")
      if (!this.seekbarUpdateTimer) this.seekbarUpdateInterval();

      this.$video.pause();
      this.setState({
        isPlaying: false
      });
    }
  }, {
    key: "_play",
    value: function _play() {
      //console.log("pause")
      if (!this.seekbarUpdateTimer) this.seekbarUpdateInterval();

      if (this.$video.currentTime >= this.$video.duration) this.$video.currentTime = 0;
      this.$video.play();
      this.setState({
        isPlaying: true
      });
    }
  }, {
    key: "_toggleMute",
    value: function _toggleMute() {
      if (this.state.volume === 0) {
        this._volume(0.7);
      } else {
        this._volume(0);
      }
    }
  }, {
    key: "_fullscreen",
    value: function _fullscreen(e) {
      var apis = ["requestFullScreen", "mozRequestFullScreen", "webkitRequestFullscreen", "msRequestFullscreen"];
      for (var ii = 0; ii < apis.length; ii++) {
        if (this.$video[apis[ii]]) return this.$video[apis[ii]]();
      }
    }
  }, {
    key: "_volume",
    value: function _volume(val) {
      if (val <= 0) val = 0;
      if (val > 1) val = 1;
      this.$video.volume = val;
      var state = {
        volume: val,
        isMuted: val <= 0.05 ? true : false
      };
      this.setState(state);
    }
  }, {
    key: "_toggleSubtitle",
    value: function _toggleSubtitle() {
      var state = {};

      if (this.$video.textTracks[this.state.activeSubtitle]) {
        if (this.$video.textTracks[this.state.activeSubtitle].mode === "disabled") {
          this.$video.textTracks[this.state.activeSubtitle].mode = "showing";
          state.isSubtitled = true;
        } else {
          this.$video.textTracks[this.state.activeSubtitle].mode = "disabled";
          state.isSubtitled = false;
        }
      }
      this.setState(state);
    }
  }, {
    key: "_setSubtitle",
    value: function _setSubtitle(index) {
      //console.log("_setSubtitle",index)
      if (this.$video.textTracks[this.state.activeSubtitle]) this.$video.textTracks[this.state.activeSubtitle].mode = "disabled";
      this.$video.textTracks[index].mode = "showing";
      this.setState({
        activeSubtitle: index
      });
    }
  }, {
    key: "$getSubtitleTracksMenu",
    value: function $getSubtitleTracksMenu() {
      var _this2 = this;

      var $menuItems = [];
      if (!this.$video || this.$video.textTracks.length <= 0) return $menuItems;

      var _loop = function _loop(ii) {
        var track = _this2.$video.textTracks[ii];
        $menuItems.push(_react2.default.createElement(
          "li",
          { key: ii },
          _react2.default.createElement(
            "button",
            { onClick: function onClick(e) {
                return _this2._setSubtitle(ii);
              } },
            track.label
          )
        ));
      };

      for (var ii = 0; ii < this.$video.textTracks.length; ii++) {
        _loop(ii);
      }
      this.subTitleMenu = _react2.default.createElement(
        "span",
        { className: "r5-subtitle" },
        _react2.default.createElement(
          "button",
          null,
          this.icons.subtitles
        ),
        _react2.default.createElement(
          "ul",
          { className: "r5-subtitle-menu" },
          $menuItems
        )
      );
      return this.subTitleMenu;
    }

    // generate subtitle tracks: <track >

  }, {
    key: "$getSubtitleTracks",
    value: function $getSubtitleTracks(subtitles, subtitleOn) {
      if (!Array.isArray(subtitles)) return "";
      var $tracks = [];
      for (var ii = 0; ii < subtitles.length; ii++) {
        var track = subtitles[ii];
        $tracks.push(_react2.default.createElement("track", { src: track.src, kind: "subtitles", srcLang: track.lang, label: track.label, key: ii, "default": subtitleOn }));
      }
      return $tracks;
    }
  }, {
    key: "$getSource",
    value: function $getSource(sources) {
      if (!Array.isArray(sources)) return [];
      var $sources = [];
      for (var ii = 0; ii < sources.length; ii++) {
        var src = void 0,
            type = void 0;
        if ((0, _typeof3.default)(sources[ii]) === 'object') {
          src = sources[ii].src;
          type = sources[ii].type;
        } else {
          src = sources[ii];
          type = "video/" + _path2.default.extname(src).substr(1).split('?')[0];
        }
        $sources.push(_react2.default.createElement("source", { src: src, type: type, key: ii }));
      }
      return $sources;
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _props = this.props,
          subtitles = _props.subtitles,
          subtitleOn = _props.subtitleOn,
          loop = _props.loop,
          autoPlay = _props.autoPlay,
          poster = _props.poster,
          preload = _props.preload,
          sources = _props.sources,
          controlPanelStyle = _props.controlPanelStyle,
          autoHideControls = _props.autoHideControls;
      //html5 video options

      var options = {
        loop: loop,
        autoPlay: autoPlay,
        poster: poster,
        preload: preload
      };
      var wraperStyle = {},
          contentWraperStyle = {};
      var $video = this.$video || {};
      var vWidth = this.props.width || $video.videoWidth || $video.clientWidth;
      var vHeight = this.props.height || $video.videoHeight || $video.clientHeight;
      options.width = vWidth;
      options.height = vHeight;
      wraperStyle.width = vWidth + "px";
      wraperStyle.height = contentWraperStyle.height = vHeight + "px";
      if (this.props.controlPanelStyle == "fixed") wraperStyle.height = vHeight + 50 + "px";

      var wraperClass = "r5-wraper " + this.props.layout;
      var controlsClass = "r5-controls r5-controls--" + controlPanelStyle + " " + (autoHideControls ? "r5-auto-hide" : "") + " ";
      if (!this.props.controls) controlsClass = "r5-controls-hidden";
      var subsClass = "r5-subtitle";
      if (!this.state.isSubtitled) subsClass += " r5-subs-hidden";

      return _react2.default.createElement(
        "div",
        { className: wraperClass, style: wraperStyle },
        _react2.default.createElement(
          "video",
          (0, _extends3.default)({ ref: "video" }, options),
          this.$getSource(sources),
          subtitles && subtitles.length > 0 ? this.$getSubtitleTracks(subtitles, subtitleOn) : ""
        ),
        _react2.default.createElement(
          "div",
          { className: "r5-overlay", onClick: this._togglePlay },
          !this.$video || this.$video.currentTime <= 0 ? this.icons.playCircle : ""
        ),
        _react2.default.createElement(
          "div",
          { className: "r5-content", style: contentWraperStyle },
          this.props.children
        ),
        _react2.default.createElement(
          "div",
          { className: controlsClass },
          _react2.default.createElement(
            "div",
            { className: "r5-panel" },
            _react2.default.createElement(
              "button",
              { className: "r5-play custom-pos", onClick: this._togglePlay },
              this.state.isPlaying ? this.icons.pause : this.icons.play
            ),
            _react2.default.createElement(
              "div",
              { className: "r5-seekbar-wraper", ref: "seekbarWraper" },
              _react2.default.createElement("div", { className: "r5-seekbar-loaded", ref: "seekbar", style: { width: this.state.loadedProgress + "%" } }),
              _react2.default.createElement("div", { className: "r5-seekbar", ref: "loadedbar", style: { width: this.state.seekProgress + "%" } }),
              _react2.default.createElement("input", { type: "range", min: "0.0", max: "100.0", step: "0.5", value: this.state.seekProgress, onChange: function onChange(e) {
                  return _this3._setTime(e.target.value, true);
                } })
            ),
            _react2.default.createElement(
              "div",
              { className: "r5-controls-wraper" },
              _react2.default.createElement(
                "span",
                { className: "r5-timecode" },
                this.state.currentTime
              ),
              _react2.default.createElement(
                "div",
                { className: subsClass },
                _react2.default.createElement(
                  "button",
                  { className: "custom-pos", onClick: this._toggleSubtitle },
                  this.props.icons.subtitles || this.icons.subtitles
                )
              ),
              _react2.default.createElement(
                "div",
                { className: "r5-volume" },
                _react2.default.createElement(
                  "button",
                  { className: "custom-pos", onClick: this._toggleMute },
                  this.state.isMuted ? this.props.icons.mute || this.icons.mute : this.props.icons.sound || (this.state.volume > 0.7 ? this.icons.volumeUp : this.icons.volumeDown)
                ),
                _react2.default.createElement(
                  "div",
                  { className: "r5-volume-inner", style: { width: "6px", height: "80px" } },
                  _react2.default.createElement("div", { className: "r5-volume-bar", style: { height: this.state.volume * 100 + "%" } }),
                  _react2.default.createElement("input", { orient: "vertical", type: "range", min: "0", max: "1", step: "0.05", value: this.state.volume, onChange: function onChange(e) {
                      return _this3._volume(e.target.value);
                    } })
                )
              ),
              _react2.default.createElement(
                "button",
                { className: "r5-fullscreen", onClick: this._fullscreen },
                this.icons.fullscreen
              )
            )
          )
        )
      );
    }
  }, {
    key: "componentWillMount",
    value: function componentWillMount() {

      this.state = {
        isPlaying: this.props.autoPlay ? true : false,
        isMuted: false,
        isSubtitled: this.props.isSubtitled ? true : false,
        currentTime: "00:00",
        duration: "00:00",
        loadedProgress: 0,
        seekProgress: 0, // how much has played
        volume: this.props.volume || 1,
        activeSubtitle: this.props.activeSubtitle === undefined ? null : this.props.activeSubtitle,
        seekDisabled: this.props.seekDisabled ? true : false
      };

      // var fill = this.props.controlPanelStyle == "overlay"?"#ffffff":"#3FBA97";
      var fill = "#ffffff";
      this.icons = {};
      this.icons.play = _react2.default.createElement("i", { className: "icon-play" });
      this.icons.pause = _react2.default.createElement("i", { className: "icon-pause" });
      this.icons.playCircle = _react2.default.createElement("i", { className: "icon-circle-play" });
      this.icons.volumeUp = _react2.default.createElement("i", { className: "icon-circle-unmute" });
      this.icons.volumeDown = _react2.default.createElement("i", { className: "icon-circle-unmute" });
      this.icons.mute = _react2.default.createElement("i", { className: "icon-circle-mute" });
      this.icons.subtitles = _react2.default.createElement("i", { className: "icon-circle-subtitle" });
      this.icons.fullscreen = _react2.default.createElement("i", { className: "icon-fullscreen" });
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var $video = this.$video = this.api.$video = _reactDom2.default.findDOMNode(this.refs.video);
      $video.removeEventListener("loadedmetadata", this._metaDataLoaded);
      $video.removeEventListener("ended", this._ended);
      $video.removeEventListener("progress", this._progress);
      if (this.seekbarUpdateTimer) clearInterval(this.seekbarUpdateTimer);
    }
  }]);
  return Video;
}(_react.Component);

Video.propTypes = {
  // callbacks
  metaDataLoaded: _react.PropTypes.func, // video's meta data loaded, return video element
  ended: _react.PropTypes.func,

  // properties
  sources: _react.PropTypes.array,
  subtitles: _react.PropTypes.array, // [{src:"foo.vtt", label:"English",srclan:"en" }]
  autoPlay: _react.PropTypes.bool,
  controls: _react.PropTypes.bool,
  autoHideControls: _react.PropTypes.bool,
  controlPanelStyle: _react.PropTypes.oneOf(["overlay", "fixed"]), // overlay, fixed
  preload: _react.PropTypes.oneOf(["auto", "none", "metadata"]),
  loop: _react.PropTypes.bool,
  mute: _react.PropTypes.bool,
  icons: _react.PropTypes.object,
  layout: _react.PropTypes.string,
  poster: _react.PropTypes.string,
  width: _react.PropTypes.string,
  height: _react.PropTypes.string,
  volume: _react.PropTypes.number,
  activeSubtitle: _react.PropTypes.number,
  seekDisabled: _react.PropTypes.bool,
  isSubtitled: _react.PropTypes.bool

};

Video.defaultProps = {
  autoPlay: false,
  loop: false,
  controls: true,
  autoHideControls: true,
  volume: 1.0,
  mute: false,
  layout: "",
  icons: {},
  controlPanelStyle: "overlay",
  preload: "auto",
  seekDisabled: false
};

exports.default = Video;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Media/Video.js
// module id = 349
// module chunks = 0